<template>
	<section class="m-card" v-if="data.text.length > 0 || data.video.length > 0">
		<h2 class="m-card-title">最新影音</h2>
		<ClientOnly>
			<ul class="video-ul">
				<li v-for="item in data.video.slice(0, 6)" :key="item.id">
					<div class="mark" @click="play(item)"></div>
					<nativeVideo
						class="nativeVideo"
						:url="item.media_url[0]"
						:playerId="'video-' + item.id"
						:config="nativeVideoConfig"
					></nativeVideo>
				</li>
			</ul>
			<!-- 弹窗播放 -->
			<n-modal
				v-model:show="showPlayer"
				:trap-focus="true"
				:mask-closable="true"
				:close-on-esc="true"
				:auto-focus="true"
				:block-scroll="true"
				:z-index="1000"
				@after-enter="handleModalOpen"
				@after-leave="handleModalClose"
			>
				<div class="modal-content" tabindex="-1">
					<nativeVideo
						class="nativeVideo"
						:url="playData.media_url[0]"
						:playerId="'modal-player-' + playData.id"
						:config="nativeVideoConfig"
					></nativeVideo>
				</div>
			</n-modal>
			<template #fallback>
				<div class="loading-placeholder">加載中...</div>
			</template>
		</ClientOnly>
	</section>
</template>

<script setup>
import { ref } from "vue";
import nativeVideo from "~/components/nativeVideo/index.vue";

defineProps({
	data: {
		type: Object,
		default: { text: [], video: [] },
	},
});

const nativeVideoConfig = {
	width: "100%",
	height: "100%",
	autoplay: true,
	autoplayMuted: true,
	muted: true,
	loop: true,
	controls: false,
	fluid: true,
	responsive: true,
};

const playConfig = {
	width: "100%",
	height: "100%",
	autoplay: true,
	autoplayMuted: true,
	muted: true,
	loop: true,
	controls: true,
	fluid: true,
	responsive: true,
	fill: true,
};

const showPlayer = ref(false);
const playData = ref({});
const play = item => {
	playData.value = item;
	showPlayer.value = true;
};

// 处理模态框焦点管理
const handleModalOpen = () => {
	// 设置主内容区域为inert（如果浏览器支持）
	const mainContent = document.querySelector("main") || document.querySelector("#__nuxt");
	if (mainContent && "inert" in HTMLElement.prototype) {
		mainContent.inert = true;
	}
};

const handleModalClose = () => {
	// 恢复主内容区域的交互性
	const mainContent = document.querySelector("main") || document.querySelector("#__nuxt");
	if (mainContent && "inert" in HTMLElement.prototype) {
		mainContent.inert = false;
	}
};
</script>

<style lang="scss" scoped>
.m-card {
	margin-top: 64px;
	padding: 0 32px;
	font-family: PingFang SC;
}

.loading-placeholder {
	text-align: center;
	padding: 40px;
	color: #666;
	font-size: 14px;
}

.m-card-title {
	font-weight: 600;
	font-size: 40px;
	color: #333333;
	line-height: 60px;
}

.title,
.desc {
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
}

.text-ul {
	padding: 16px;
	padding-left: 24px;
	display: flex;
	flex-direction: column;
	margin-top: 32px;
	background: #ffffff;
	border-radius: 8px;

	li {
		padding: 16px;
		padding-left: 0;
		display: flex;
		align-items: center;
		width: 100%;
		height: 88px;
		cursor: pointer;
		overflow: hidden;
		border-bottom: 2px dashed rgba(217, 217, 255, 0.5);

		&:last-child {
			border-bottom: none;
		}

		.title {
			width: 500px;
			font-weight: 500;
			font-size: 23px;
			color: #1f2329;
			display: -webkit-box;
			-webkit-box-orient: vertical;
			-webkit-line-clamp: 1;
			overflow: hidden;
			text-overflow: ellipsis;
		}

		.text {
			margin-left: auto;
			font-size: 23px;
			color: #646a73;
		}

		.icon {
			margin-right: 16px;
			margin-left: 6px;
			width: 36px;
			height: 36px;
		}
	}
}

.video-ul {
	margin-top: 32px;
	display: flex;
	overflow-x: scroll;

	li {
		flex-shrink: 0;
		margin-right: 16px;
		display: flex;
		flex-direction: column;
		position: relative;
		width: 260px;
		height: 358px;
		border-radius: 16px;
		overflow: hidden;

		.mark {
			width: 100%;
			height: 100%;
			background-color: transparent;
			position: relative;
			z-index: 9;
		}

		.nativeVideo {
			width: 260px;
			height: 358px;
			position: absolute;
			top: 0;
			left: 0;
			z-index: 0;
		}
	}
}

.play-dialog {
	width: 100vw;
	height: 70vh;
	border-radius: 8px;
	overflow: hidden;
}

.modal-content {
	width: 750px;
	outline: none;
	border-radius: 8px;
	overflow: hidden;
	position: relative;
	z-index: 1001;
}
</style>
